<template>
	<div>
	  <div class="red_top_bg">
		<div
		  class="back_left"
		  @click="$router.back()"
		/>
		<div class="big_tit">
		  {{ $t('pagea.jfsc') }}
		</div>
	  </div>
	  <div style="">
		  <van-list
		    v-model="loading"
		    :finished="finished"
		    :finished-text="$t('pagea.mygdl')"
		    @load="getdata"
		  >
		    <div class="data_list">
				<div class="data_item" v-for="(item,index) in list" :key="index"  @click="todetail(item)">
					<img class="data_img" :src="item.img"/>
					<div class="data_name">
						{{ item[lang] }}
					</div>
					<div class="data_score">
						{{ item.num}}<span style="margin-left: 5px;font-weight: 500;">{{ $t('pagea.jf') }}</span>
					</div>
				</div>
			</div>
		  </van-list>
	  </div>
	</div>
</template>

<script>
    import Fetch from '../../utils/fetch'
	import Vue from 'vue';
	import { List } from 'vant';
	
	Vue.use(List);
	export default{
		data(){
			return{
				lang:this.$i18n.locale||"zh_cn",
				 list: [],
				  loading: false,
				  finished: false,
				page:1,
			}
		},
        created() {
            this.$parent.footer('user', false);
        },
		mounted() {
			//this.getdata();
		},
		methods:{
			todetail(item){
				this.$router.push("/gooddetail/"+item.id);
			},
			getdata(){
				let self=this;
				Fetch('/index/getgoods', {page: this.page}).then((res) => {
					let result=res.data;
					self.list=self.list.concat(res.data);
					// 加载状态结束
					self.loading = false;
					self.page++;
					// 数据全部加载完成
					if (result != 0) {
						self.finished = true;
					}
					if (result == 0&&self.page>1) {
						self.page--;
						self.finished = true;
					}
				});
			},
		}
	}
	
	
</script>

<style lang="less" scoped>
	.data_list{
		display: flex;
		flex-wrap: wrap;
		padding: 10px;
	}
	.data_item{
		width: calc(calc(100% - 10px)/2);
		margin-bottom: 5px;
		&:not(:nth-child(2n)){
			margin-right: 5px;
		}
		.data_img{
			width: 100%;
		}
	}
	.data_name{
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		color: #fff;
		font-size: 16px;
		padding: 5px 0;
		font-weight: bold;
	}
	.data_score{
		font-size: 16px;
		color: red;
		font-weight: 600;
	}
</style>